import { useEffect } from 'react';
import { t } from '../lib/i18n';

export const useLocalizedValidation = locale => {
  useEffect(() => {
    const validate = event => {
      const input = event.target;
      if (!input.validity || !input.setCustomValidity) return;
      input.setCustomValidity('');
      if (input.validity.valid) return;
      const key = input.validity.valueMissing ? 'This field is required' : input.validity.typeMismatch && input.type === 'email' ? 'Enter a valid email address' : 'Check the entered details';
      input.dataset.maldhowrValidation = 'true';
      input.setCustomValidity(t(key));
    };
    const clear = event => { if (event.target.dataset?.maldhowrValidation) { event.target.setCustomValidity(''); delete event.target.dataset.maldhowrValidation; } };
    document.querySelectorAll('[data-maldhowr-validation]').forEach(input => validate({ target: input }));
    document.addEventListener('invalid', validate, true);
    document.addEventListener('input', clear, true);
    document.addEventListener('change', clear, true);
    return () => { document.removeEventListener('invalid', validate, true); document.removeEventListener('input', clear, true); document.removeEventListener('change', clear, true); };
  }, [locale]);
};